import actions from '../../actionTypes';

export default (siteId) => {
  return {
    type: actions.GET_SITE_USER,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/getSiteUser.js